import { buildWjsEmbedScriptUrl } from "~/lib/widget-script";

export const PROJECT_CTA_UPDATED_EVENT = "easygpt-project-cta-updated";

/** Parent → widget iframe: refetch project settings (CTA clusters) without full page reload. */
export const WIDGET_CTA_REFRESH_MESSAGE_TYPE = "easygpt-refresh-project-cta";

export type ProjectCtaUpdatedDetail = { projectId: string };

function postCtaRefreshToWidgetIframes(projectId: string) {
  const payload = { type: WIDGET_CTA_REFRESH_MESSAGE_TYPE, projectId };
  document.querySelectorAll("iframe").forEach((iframe) => {
    const src = iframe.getAttribute("src") ?? "";
    if (src.includes(`/w/${projectId}`)) {
      iframe.contentWindow?.postMessage(payload, "*");
    }
  });
}

export function dispatchProjectCtaUpdated(projectId: string) {
  if (typeof window === "undefined") return;
  window.dispatchEvent(
    new CustomEvent<ProjectCtaUpdatedDetail>(PROJECT_CTA_UPDATED_EVENT, {
      detail: { projectId },
    }),
  );
  postCtaRefreshToWidgetIframes(projectId);
}

/** Remove w.js launcher, iframe shell, and script tags so a fresh embed can load. */
export function removeEasygptWidgetFromDom() {
  if (typeof document === "undefined") return;

  document.querySelectorAll('[id^="easygpt-"]').forEach((el) => el.remove());
  document
    .querySelectorAll('script[src*="/w.js"],script[src*="/w-v2.js"]')
    .forEach((el) => el.remove());

  const win = window as Window & { easyGPTOpen?: unknown };
  delete win.easyGPTOpen;
}

export function reloadEasygptPreviewWidget(
  projectId: string,
  opts?: { origin?: string; variantB?: boolean; scriptId?: string },
) {
  if (typeof document === "undefined" || !projectId) return;

  removeEasygptWidgetFromDom();

  const origin = opts?.origin ?? window.location.origin;
  const script = document.createElement("script");
  script.id = opts?.scriptId ?? `easygpt-preview-widget-${projectId}`;
  script.async = true;
  script.src = buildWjsEmbedScriptUrl(origin, projectId, {
    variantB: opts?.variantB,
    reloadKey: Date.now(),
  });
  document.body.appendChild(script);
}
